<script>
    import { createEventDispatcher } from 'svelte';

    import Icon from './Icon.svelte';

    let className = '';
    export { className as class };

    export let nop = false;
    export let xxs = false;
    export let xs = false;
    export let sm = false;
    export let lg = false;
    export let xl = false;
    export let xxl = false;

    export let primary = false;
    export let danger = false;
    export let faded = false;
    export let success = false;
    export let link = false;
    export let translucent = false;

    export let outline = false;
    export let invert = false;
    export let text = false;

    export let pill = false;
    export let round = false;

    export let right = false;
    export let left = false;

    export let rounded = true;

    export let block = false;

    export let submit = false;
    export let disabled = false;

    export let stopPropagation = false;
    export let preventDefault = false;

    export let animated = true;

    // With a route the button renders as a real link, so it works without JS
    // and agents can follow it. Add `preventDefault` to keep the link in the
    // HTML but handle the click in JS instead (e.g. PurchasePaddle).
    export let route = '';
    export let external = false;
    export let loading = false;
    export let loading_spinner = false;
    export let aria_label = '';

    const dispatch = createEventDispatcher();

    const handleClick = (e) => {
        // A disabled <button> never fires click, but a link does; swallow it
        // so wrappers (PurchasePaddle's click handler) don't react either.
        if (route && (disabled || loading)) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        if (stopPropagation) e.stopPropagation();
        if (preventDefault) e.preventDefault();

        dispatch('click', e);
    };
</script>

<!-- Always a link with href or a <button>, both interactive already. -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<svelte:element
    this={route ? 'a' : 'button'}
    on:click={handleClick}
    href={route || undefined}
    target={route && external ? '_blank' : undefined}
    rel={route && external ? 'noopener noreferrer' : undefined}
    data-sveltekit-preload-data={route && preventDefault ? 'off' : undefined}
    aria-disabled={route && disabled ? 'true' : undefined}
    disabled={route ? undefined : disabled || loading}
    type={route ? undefined : submit ? 'submit' : 'button'}
    aria-label={aria_label || undefined}
    class="
        btn
        {route ? 'not-prose' : ''}
        {primary
        ? 'btn-primary'
        : faded
        ? 'btn-faded'
        : success
        ? 'btn-success'
        : danger
        ? 'btn-danger'
        : translucent
        ? 'btn-translucent'
        : ''}
        {link ? 'btn-link' : text ? 'btn-text' : outline ? 'btn-outline' : ''}
        {invert ? 'btn-invert' : ''}
        {!animated ? 'btn-not-animated' : ''}
        {xxs
        ? 'btn-xxs'
        : xs
        ? 'btn-xs'
        : sm
        ? 'btn-sm'
        : lg
        ? 'btn-lg'
        : xl
        ? 'btn-xl'
        : xxl
        ? 'btn-xxl'
        : ''}
        {nop ? 'btn-nop' : ''}
        {pill ? 'btn-pill' : ''}
        {round ? 'btn-round' : ''}
        {!pill && !round && !rounded ? 'btn-unrounded' : ''}
        {left ? 'btn-left' : ''}
        {right ? 'btn-right' : ''}
        {block ? 'btn-block' : ''}
        {disabled ? 'btn-disabled' : ''}
        {loading ? 'btn-loading' : ''}
        {loading && !loading_spinner ? 'btn-loading-pulse' : ''}
        {loading && loading_spinner ? 'btn-loading-spinner' : ''}
        {className}
    "
>
    {#if $$slots.small}
        <span class="btn-content">
            <span class="btn-main"><slot /></span>
            <small
                class="block
                    {xxs || xs || sm
                    ? 'text-xs'
                    : lg
                    ? 'text-sm'
                    : xl
                    ? 'text-md'
                    : xxl
                    ? 'text-lg'
                    : ''}"
            >
                <slot name="small" />
            </small>
        </span>
    {:else}
        <slot />
    {/if}
    {#if loading && loading_spinner}
        <Icon spin icon="loading" class="btn-spinner" />
    {/if}
</svelte:element>
